"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// 适配 Nginx 反向代理
var baseUrl = process.env.VUE_APP_BASE_API === '/' ? '' : process.env.VUE_APP_BASE_API;
var api = {
  state: {
    // 部署包上传
    deployUploadApi: baseUrl + '/api/deploy/upload',
    // SQL脚本上传
    databaseUploadApi: baseUrl + '/api/database/upload',
    // 实时控制台
    socketApi: baseUrl + '/websocket?token=kl',
    // 图片上传
    imagesUploadApi: baseUrl + '/api/oss/upload',
    // 文件上传
    filesUploadApi: baseUrl + '/api/oss/upload',
    // 修改头像
    updateAvatarApi: baseUrl + '/api/users/updateAvatar',
    // 上传文件到七牛云
    qiNiuUploadApi: baseUrl + '/api/qiNiuContent',
    // Sql 监控
    sqlApi: baseUrl + '/druid/index.html',
    // swagger
    swaggerApi: baseUrl + '/swagger-ui.html',
    // 文件上传
    fileUploadApi: baseUrl + '/api/localStorage',
    // 文件上传
    fileUploadTWApi: baseUrl + '/api/cmsTechnologyTutorial',
    // 图片预览前缀
    imgPreviewPrefix: 'https://oss.aiggf.cn/upload/image/',
    // 文件预览前缀
    filePreviewPrefix: 'https://oss.aiggf.cn/upload/file/',
    // 视频预览前缀
    videoPreviewPrefix: 'https://oss.aiggf.cn/upload/video/',
    // 百度地图API
    baiduMapApi: 'https://api.map.baidu.com/api?v=2.0&ak=OBm3M500kYqYmqtXYcKpXfI5PXSH7tIA',
    // 高德地图API
    amapApi: 'https://webapi.amap.com/maps?v=2.0&key=959c88d0b321580e95dbdbe3bad1676a',
    // 高德地图安全密钥
    amapSecurityJsCode: 'b455ae9537efacca06cdd0d661b563da',
    // baseUrl，
    baseApi: baseUrl,
    // 酷家乐设计方案地址模板测试地址
    coolHomeDesignUrl: '/DesignScheme.html?kuJiaLeFrameUrl={kuJiaLeFrameUrl}&contractId={contractId}&userName={userName}&apiBaseUrl=' + encodeURIComponent(baseUrl)
  }
};
var _default = api;
exports.default = _default;